import { c as _c } from "react/compiler-runtime";
import { useState } from 'react';
import clsx from 'clsx';
import { HeaderTile } from '@/types/headerHierarchy';
import { useMediaQuery } from '@/hooks/useMediaQuery';
import ProgressBar from '@/components/ProgressBar/ProgressBar';
import { LazyAmplienceResponsiveImage } from '@/components/ResponsiveImage/LazyAmplienceResponsiveImage';
import Slider from '@/components/Slider/Slider';
import AmplienceLink from '../Common/AmplienceLink';
type MenuTile = {
  tile: HeaderTile;
  isSingleImage: boolean;
  isSlider?: boolean;
  tileKey: string;
};
const MenuTile = t0 => {
  const $ = _c(25);
  const {
    tile,
    isSingleImage,
    isSlider: t1,
    tileKey
  } = t0;
  const isSlider = t1 === undefined ? false : t1;
  const t2 = tile.link;
  const t3 = isSingleImage ? "aspect-6/4" : "aspect-3/4";
  let t4;
  if ($[0] !== t3) {
    t4 = clsx(t3, "h-full max-h-80");
    $[0] = t3;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  let t5;
  if ($[2] !== tile.image.image) {
    t5 = {
      src: tile.image.image,
      sizes: "340px"
    };
    $[2] = tile.image.image;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  const t6 = tile.image.altText ?? "";
  let t7;
  if ($[4] !== t5 || $[5] !== t6) {
    t7 = <LazyAmplienceResponsiveImage source={t5} alt={t6} />;
    $[4] = t5;
    $[5] = t6;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  let t8;
  if ($[7] !== t4 || $[8] !== t7) {
    t8 = <div className={t4}>{t7}</div>;
    $[7] = t4;
    $[8] = t7;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  const t9 = isSlider ? "font-inter" : "font-made";
  let t10;
  if ($[10] !== t9) {
    t10 = clsx(t9, "mt-2 overflow-hidden text-sm leading-tight text-ellipsis");
    $[10] = t9;
    $[11] = t10;
  } else {
    t10 = $[11];
  }
  let t11;
  if ($[12] !== t10 || $[13] !== tile.link.label) {
    t11 = <span className={t10}>{tile.link.label}</span>;
    $[12] = t10;
    $[13] = tile.link.label;
    $[14] = t11;
  } else {
    t11 = $[14];
  }
  let t12;
  if ($[15] !== tile.subheadline) {
    t12 = tile?.subheadline && <span className="block text-sm">{tile?.subheadline}</span>;
    $[15] = tile.subheadline;
    $[16] = t12;
  } else {
    t12 = $[16];
  }
  let t13;
  if ($[17] !== t11 || $[18] !== t12) {
    t13 = <div className="flex flex-col">{t11}{t12}</div>;
    $[17] = t11;
    $[18] = t12;
    $[19] = t13;
  } else {
    t13 = $[19];
  }
  let t14;
  if ($[20] !== t13 || $[21] !== t8 || $[22] !== tile.link || $[23] !== tileKey) {
    t14 = <AmplienceLink key={tileKey} link={t2} className="flex h-full cursor-pointer flex-col hover:opacity-80">{t8}{t13}</AmplienceLink>;
    $[20] = t13;
    $[21] = t8;
    $[22] = tile.link;
    $[23] = tileKey;
    $[24] = t14;
  } else {
    t14 = $[24];
  }
  return t14;
};
type MenuSlider = {
  tiles: HeaderTile[];
  className?: string;
  showNavigation?: boolean;
  noPadding?: boolean;
};
export const MenuSlider = t0 => {
  const $ = _c(41);
  const {
    tiles,
    className,
    showNavigation,
    noPadding: t1
  } = t0;
  const noPadding = t1 === undefined ? false : t1;
  const [progress, setProgress] = useState(0);
  const isDesktop = useMediaQuery("(min-width: 1280px) and (pointer: fine)");
  const showSlider = isDesktop ? tiles.length > 4 : tiles.length > 2;
  const isSingleImage = tiles.length === 1;
  if (showSlider) {
    let t2;
    if ($[0] !== className) {
      t2 = clsx(className, "relative h-full");
      $[0] = className;
      $[1] = t2;
    } else {
      t2 = $[1];
    }
    const t3 = !isDesktop ? "px-4!" : "md-lg:pr-8 lg:pr-16 xl:pr-22.5";
    let t4;
    if ($[2] !== t3) {
      t4 = {
        slider: t3,
        navPrev: "left-2! flex bg-black text-white lg:size-16",
        navNext: "right-16! flex bg-black text-white lg:size-16 xl:right-22.5!"
      };
      $[2] = t3;
      $[3] = t4;
    } else {
      t4 = $[3];
    }
    let t5;
    if ($[4] !== isSingleImage || $[5] !== showSlider || $[6] !== tiles) {
      let t6;
      if ($[8] !== isSingleImage || $[9] !== showSlider) {
        t6 = (tile, i) => <MenuTile key={"tile" + i} tileKey={"menutile" + i} tile={tile} isSingleImage={isSingleImage} isSlider={showSlider} />;
        $[8] = isSingleImage;
        $[9] = showSlider;
        $[10] = t6;
      } else {
        t6 = $[10];
      }
      t5 = tiles.map(t6);
      $[4] = isSingleImage;
      $[5] = showSlider;
      $[6] = tiles;
      $[7] = t5;
    } else {
      t5 = $[7];
    }
    let t6;
    if ($[11] !== noPadding || $[12] !== showNavigation || $[13] !== t4 || $[14] !== t5) {
      t6 = <Slider isImageRenderOptimized={false} className={t4} showNavigation={showNavigation} onProgressChange={setProgress} noPadding={noPadding}>{t5}</Slider>;
      $[11] = noPadding;
      $[12] = showNavigation;
      $[13] = t4;
      $[14] = t5;
      $[15] = t6;
    } else {
      t6 = $[15];
    }
    const t7 = !isDesktop ? "mx-4" : "mr-16 xl:mr-22.5";
    let t8;
    if ($[16] !== t7) {
      t8 = clsx(t7, "mt-5!");
      $[16] = t7;
      $[17] = t8;
    } else {
      t8 = $[17];
    }
    let t9;
    if ($[18] !== t8) {
      t9 = {
        root: t8,
        progress: "duration-0!"
      };
      $[18] = t8;
      $[19] = t9;
    } else {
      t9 = $[19];
    }
    const t10 = tiles.length >= 4;
    let t11;
    if ($[20] !== progress || $[21] !== t10 || $[22] !== t9) {
      t11 = <ProgressBar progress={progress} className={t9} isVisible={t10} />;
      $[20] = progress;
      $[21] = t10;
      $[22] = t9;
      $[23] = t11;
    } else {
      t11 = $[23];
    }
    let t12;
    if ($[24] !== t11 || $[25] !== t2 || $[26] !== t6) {
      t12 = <div className={t2} data-vaul-no-drag={true}>{t6}{t11}</div>;
      $[24] = t11;
      $[25] = t2;
      $[26] = t6;
      $[27] = t12;
    } else {
      t12 = $[27];
    }
    return t12;
  } else {
    const t2 = !isDesktop ? "p-4" : "md:pr-16 xl:pr-22.5";
    let t3;
    if ($[28] !== t2) {
      t3 = clsx(t2, "grid h-full w-full gap-2");
      $[28] = t2;
      $[29] = t3;
    } else {
      t3 = $[29];
    }
    const t4 = `repeat(${tiles.length}, 1fr)`;
    let t5;
    if ($[30] !== t4) {
      t5 = {
        gridTemplateColumns: t4
      };
      $[30] = t4;
      $[31] = t5;
    } else {
      t5 = $[31];
    }
    let t6;
    if ($[32] !== isSingleImage || $[33] !== tiles) {
      let t7;
      if ($[35] !== isSingleImage) {
        t7 = (tile_0, i_0) => <li key={"tile" + i_0}><MenuTile tile={tile_0} isSingleImage={isSingleImage} tileKey={"menutile" + i_0} /></li>;
        $[35] = isSingleImage;
        $[36] = t7;
      } else {
        t7 = $[36];
      }
      t6 = tiles.map(t7);
      $[32] = isSingleImage;
      $[33] = tiles;
      $[34] = t6;
    } else {
      t6 = $[34];
    }
    let t7;
    if ($[37] !== t3 || $[38] !== t5 || $[39] !== t6) {
      t7 = <ul className={t3} style={t5}>{t6}</ul>;
      $[37] = t3;
      $[38] = t5;
      $[39] = t6;
      $[40] = t7;
    } else {
      t7 = $[40];
    }
    return t7;
  }
};